import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box, Container, CssBaseline, Paper, Toolbar } from "@mui/material";
import { TypographyLarge, TypographyXLarge } from "../../customComponent";
import Sidebar from "../../sidebar/Sidebar";
import UserGroupList from "./UserGroupList";
import CreateUserGroup from "./CreateUserGroup";
import UserSuccessPrompt from "../UserSuccessPrompt";
import UserErrorPrompt from "../UserErrorPrompt";
import UserGroupFilter from "./UserGroupFilter";
import Role from "../../../helpers/roles";

const UserGroup = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("usergroup");

  const { user, features } = useSelector((state) => state.auth);
  const userRole = user?.type;
  const permission = user?.permission;
  const userGroupPermission = permission?.userGroup;

  useEffect(() => {
    if (!user?.id) {
      return;
    }

    if (features?.["USER_GROUP"] === false) {
      navigate("/");
      return;
    }

    if (!permission) {
      return;
    }

    if (userGroupPermission?.read === false && userRole !== Role.Eins) {
      navigate("/dashboard");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, features]);

  if (!features?.enabled) {
    return (
      <div style={{ display: "flex" }}>
        <Sidebar />
        <Box component="main" sx={{ flexGrow: 1, p: 1 }}></Box>
      </div>
    );
  }

  return (
    <div style={{ display: "flex" }}>
      <Sidebar />

      <Box component="main" sx={{ flexGrow: 1, p: 1 }}>
        <Toolbar />
        <CssBaseline />

        <Container maxWidth="xl">
          <Box sx={{ mb: 1 }}>
            <TypographyXLarge sx={{ fontWeight: 700 }}>
              {t("title")}
            </TypographyXLarge>
            <TypographyLarge sx={{ fontWeight: 400 }}>
              {t("titleExplain")}
            </TypographyLarge>
          </Box>

          <UserSuccessPrompt />
          <UserErrorPrompt />

          {(userGroupPermission?.create || userRole !== Role.User) && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                mb: 2,
              }}
            >
              <CreateUserGroup />
            </Box>
          )}
          <Paper
            component="section"
            elevation={2}
            sx={{ p: 2, my: 2, borderRadius: "6px" }}
          >
            <UserGroupFilter />
          </Paper>

          <UserGroupList />
        </Container>
      </Box>
    </div>
  );
};

export default UserGroup;
